module.exports = __webpack_public_path__ + "static/media/bet-report.2169ecd8.svg";